import { useState } from "react"

import { DownOutlined, UpOutlined } from "@ant-design/icons"
import { Avatar, Button, List } from "antd"
import { deleteCollaboratorThunk } from "features/common/model/slice/sharingSlice"
import { useAppDispatch } from "shared/config/store"
import { DeleteOutlined } from "shared/ui"
import { styled } from "styled-components"

const { Item } = List

export const CollaboratorsList = ({ collaborators }: { collaborators: any[] }) => {
  const [showAll, setShowAll] = useState(false)
  const dispatch = useAppDispatch()
  const handleRemoveCollaborator = (collaboratorId: string) => {
    dispatch(deleteCollaboratorThunk(collaboratorId))
  }

  if (collaborators.length === 0) {
    return null
  }

  const collaboratorsToShow = showAll ? collaborators : collaborators.slice(0, 3)

  return (
    <Container>
      <Title>
        Users with access (
        {collaborators.length}
)
      </Title>

      <List
        itemLayout="horizontal"
        dataSource={collaboratorsToShow}
        renderItem={(collaborator: any) => (
          <StyledListItem
            key={collaborator.id}
            actions={[
              <DeleteOutlined
                onClick={() => handleRemoveCollaborator(collaborator.id)}
              />,
            ]}
          >
            <Item.Meta
              avatar={(
                <Avatar>
                  {collaborator.name ? collaborator.name[0].toUpperCase() : collaborator.phone_or_email[0].toUpperCase()}
                </Avatar>
              )}
              title={collaborator.name || collaborator.phone_or_email}
              description={collaborator.name ? collaborator.phone_or_email : null}
            />
          </StyledListItem>
        )}
      />

      {collaborators.length > 3 && (
        <Button 
          style={{
            color: 'var(--color-primary)',
            marginTop: '8px',
          }}
          type="link"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? 'Show less' : `Show ${collaborators.length - 3} more`}

          {showAll ? <UpOutlined /> : <DownOutlined />}
        </Button>
      )}
    </Container>
  )
}



const Container = styled.div`
  padding: 12px 20px;
  border-radius: 6px;
  background: var(--Colors-Neutral-Bg-colorBgContainerDisabled, rgba(0, 0, 0, 0.04));
  
  .ant-list-item {
    padding: 6px 0;
  }

  .ant-btn {
    padding: 0;
    height: auto;
  }
`

const Title = styled.h4`
  font-size: 14px;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.88);
`

const StyledListItem = styled(Item)`
  padding: 0;
  align-items: center;
  border-block-end: none !important;
  

  .ant-list-item-meta {
    align-items: center !important;
  }

  .ant-list-item-meta-title {
    margin-bottom: 0 !important;
    font-weight: 400;
  }

  .ant-list-item-meta-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
` 